import { Button } from "../ui/button"
import { NovaMark } from "../layout/nova-mark"
import { initiateGoogleLogin } from "../../services/use-auth"

function GoogleIcon() {
  return (
    <svg className="size-4 shrink-0" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="#4285F4"
        d="M23.52 12.273c0-.851-.076-1.67-.218-2.455H12v4.642h6.458a5.52 5.52 0 0 1-2.394 3.622v3.011h3.878c2.269-2.089 3.578-5.165 3.578-8.82Z"
      />

      <path
        fill="#34A853"
        d="M12 24c3.24 0 5.956-1.075 7.942-2.907l-3.878-3.011c-1.075.72-2.45 1.145-4.064 1.145-3.125 0-5.771-2.111-6.715-4.947H1.276v3.109A11.995 11.995 0 0 0 12 24Z"
      />

      <path
        fill="#FBBC05"
        d="M5.285 14.28A7.213 7.213 0 0 1 4.909 12c0-.79.136-1.56.376-2.28V6.611H1.276A11.995 11.995 0 0 0 0 12c0 1.936.464 3.769 1.276 5.389l4.009-3.109Z"
      />

      <path
        fill="#EA4335"
        d="M12 4.773c1.762 0 3.344.605 4.587 1.794l3.442-3.442C17.951 1.19 15.235 0 12 0A11.995 11.995 0 0 0 1.276 6.611l4.009 3.109C6.229 6.884 8.875 4.773 12 4.773Z"
      />
    </svg>
  )
}

export function LoginCard({ redirectTo }: { redirectTo?: string | undefined }) {
  return (
    <div className="grid min-h-screen bg-card lg:grid-cols-[1.1fr_0.9fr]">
      <section className="hidden flex-col justify-between bg-primary p-12 text-primary-foreground lg:flex xl:p-16">
        <NovaMark wordmark inverted className="text-primary-foreground" />

        <div className="max-w-xl">
          <h1 className="max-w-lg text-5xl font-semibold leading-[1.05] tracking-[-0.035em] text-balance">
            Marketplace operations, in one clear view.
          </h1>

          <p className="mt-5 max-w-md text-base leading-relaxed text-primary-foreground/65">
            Revenue, fulfillment, listing health, and pipeline work—connected for the people who
            operate it.
          </p>

          <div className="mt-10 grid max-w-lg grid-cols-3 gap-px overflow-hidden rounded-xl bg-primary-foreground/15">
            {[
              ["Revenue", "Portfolio clarity"],
              ["Orders", "Exception control"],
              ["Listings", "Feed confidence"],
            ].map(([label, description]) => (
              <div key={label} className="bg-primary px-4 py-4">
                <div className="text-sm font-medium">{label}</div>

                <div className="mt-1 text-xs text-primary-foreground/55">{description}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-xs text-primary-foreground/45">GymBeam marketplace operations</div>
      </section>

      <section className="flex items-center justify-center bg-background px-6 py-12 sm:px-10">
        <div className="w-full max-w-sm">
          <img src="/gymbeam-logo.svg" alt="GymBeam" className="mb-10 h-7 w-auto" />

          <h2 className="text-3xl font-semibold tracking-tight text-foreground">Welcome to Nova</h2>

          <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
            Continue with your GymBeam Google account to open the operations workspace.
          </p>

          <Button
            variant="primary"
            className="mt-7 h-11 w-full"
            onClick={() => initiateGoogleLogin(redirectTo)}
          >
            <GoogleIcon />
            Continue with Google
          </Button>

          <p className="mt-4 text-center text-xs text-muted-foreground">
            Access is limited to authorized GymBeam accounts.
          </p>
        </div>
      </section>
    </div>
  )
}
